module.exports = __webpack_public_path__ + "static/img/dgi_img_switch.0061488.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/downloadGuideIos/dgi_img_switch.jpg
// module id = 1068
// module chunks = 1